import React from 'react'
import Text from '../../../components/text/Text'
import TableHeader from '../../../components/table/TableHeader'
import TableItem from '../../../components/table/TableItem'
import WizImage from '../../../components/image/WizImage'
import {useDisplayNumber} from '../../../utils/number'
import TableLayout from '../../../components/table/TableLayout'
import useNavigation from '../../../hooks/useNavigation'
import {useTime} from '../../../utils/time'
import {useTag} from '../../../utils/etc'
import {useImage} from '../../../utils/image'
import {IApiLog} from '../../../apis/user/getApiLog'
import useQueryExchanges from '../../../hooks/etc/useQueryExchanges'

interface IProps {
    className?: string
    data?: IApiLog[]
}

const UserListTable: React.FC<IProps> = ({className, data}) => {
    const {floorBalance} = useDisplayNumber()
    const {goKeyDetail} = useNavigation()
    const {localTimeString} = useTime()
    const {renderStateColor} = useTag()
    const {renderThumbnail} = useImage()

    const {data: ExchangeData} = useQueryExchanges()

    return (
        <div className={className}>
            <TableHeader className={'grid-cols-5 lg:grid-cols-[1fr_140px_70px_160px_190px] lg:gap-x-[10px] md:hidden'}>
                <Text>User</Text>
                <Text>Exchange</Text>
                <Text>Active</Text>
                <Text>Balance</Text>
                <Text className={'lg:text-right'}>Create At</Text>
            </TableHeader>

            <TableLayout>
                {data?.map(item => (
                    <>
                        <TableItem
                            onClick={() => {
                                goKeyDetail(item.id)
                            }}
                            key={item.id}
                            className={
                                'grid-cols-5 lg:grid-cols-[1fr_140px_70px_160px_190px] lg:gap-x-[10px] md:grid-cols-3 sm:grid-cols-1 sm:gap-y-[15px]'
                            }>
                            <div
                                className={
                                    'flex items-center space-x-[10px] md:col-span-3 md:flex-col md:text-center sm:col-span-1'
                                }>
                                <WizImage
                                    src={renderThumbnail(item.user?.thumbnail)}
                                    className={'w-[40px] h-[40px] rounded-full'}
                                />
                                <div className={'truncate '}>
                                    <Text className={'truncate md:text-ti1 md:pt-[10px]'}>{item?.user?.name}</Text>
                                    <Text className={'text-body3 text-font03 truncate'}>({item?.id})</Text>
                                </div>
                            </div>
                            <div
                                className={
                                    'flex items-center space-x-[10px] md:col-span-3 md:justify-center md:pb-[30px] sm:col-span-1 sm:pb-[10px] sm:pt-[10px]'
                                }>
                                <WizImage
                                    src={ExchangeData?.find(list => list.name === item?.exchange)?.icon}
                                    className={'w-[24px]'}
                                />
                                <Text className={'text-font02 md:text-ti2 md:text-font01'}>
                                    {ExchangeData?.find(list => list.name === item?.exchange)?.display_name}
                                </Text>
                            </div>
                            <div className={'md:space-y-[5px]'}>
                                <Text className={'hidden md:block md:text-ti3 md:text-font02 md:text-center'}>
                                    Status
                                </Text>
                                <Text className={`${renderStateColor(item?.is_active)} md:mx-auto`}>
                                    {item?.is_active ? 'Active' : 'Paused'}
                                </Text>
                            </div>
                            <div className={'md:space-y-[5px]'}>
                                <Text className={'hidden md:block md:text-ti3 md:text-font02 md:text-center'}>
                                    Balance
                                </Text>
                                <Text className={'text-ti2 md:text-center'}>{floorBalance(item?.balance)}</Text>
                            </div>

                            <div className={'md:space-y-[5px]'}>
                                <Text className={'hidden md:block md:text-ti3 md:text-font02 md:text-center'}>
                                    Create At
                                </Text>
                                <Text className={'text-font03 lg:text-right md:text-center'}>
                                    {localTimeString(new Date(item?.created_at)?.getTime() / 1000)}
                                </Text>
                            </div>
                        </TableItem>
                    </>
                ))}
            </TableLayout>
        </div>
    )
}

export default UserListTable
